const isCookieConsentGiven = (): boolean =>
  localStorage.getItem('isCookieConsentGiven') === 'true' ? true : false

const acceptCookieConsent = () => {
  localStorage.setItem('isCookieConsentGiven', 'true')
}

export { isCookieConsentGiven, acceptCookieConsent }
